import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.VerifyNumber = {
  displayName: 'Number Verification',

  buttonLayout() {
    return 'none'
  },

  onSubmit: function(onStepProgression) {
    onStepProgression()
  },

  component: React.createClass({
    getInitialState: function() {
      return {
        loading: false,
        phoneNumber: Job.Data.phoneNumber || '',
        submitEnabled: false,
        verificationStatus: '',
        verificationCodeHasError: false,
        maxCodeLength: 4
      }
    },

    componentDidMount: function() {
      if (SS.appFn.userLoggedIn() && SS.appFn.userHasVerifiedPhone()) {
        this.props.onStepProgression()
        return
      }

      Job.Actions.updatePhoneNumberEditRequested(false)
      this.loadPhoneNumber()
      this.setupPhoneVerification()
    },

    loadPhoneNumber: function() {
      if (Job.Data.phoneNumber) {
        this.setState({ phoneNumber: Job.Data.phoneNumber })
        return
      }

      if (typeof SS.currentUserId === 'undefined' || SS.currentUserId === null) {
        this.setState({ phoneNumber: '' })
        return
      }

      $.ajax(SS.API.V3.userGet({ id: SS.currentUserId }))
        .done((response) => {
          let phoneNumber = response.data.attributes.phone || ''

          Job.Actions.updatePhoneNumber(phoneNumber)
          this.setState({ phoneNumber: phoneNumber })
        })
    },

    componentDidUpdate: function() {
      if ((Job.Data.phoneNumber || '') !== this.state.phoneNumber) {
        this.setState({ phoneNumber: Job.Data.phoneNumber || '' })
      }
    },

    updateVerificationStatus: function(status, response) {
      let verificationRequired = Job.Data.phoneVerificationRequired

      if (status === 'verified') {
        SS.userPhoneVerified = true
        this.setState({ verificationCodeHasError: false })
        this.props.onStepProgression()
        return
      }

      if (status === 'skipped') {
        this.setState({ verificationCodeHasError: false })
        this.props.onStepProgression()
        return
      }

      if (status === 'pending' && response && response.reset_from_skipped) {
        SS.userPhoneIsValid = false
        SS.userPhoneVerified = false
        Job.Actions.updatePhoneNumberEditRequested(true)
        this.setState({ verificationCodeHasError: false })
        JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Contact)
        return
      }

      if (status === 'unavailable') {
        SS.userPhoneIsValid = false
        SS.userPhoneVerified = false

        if (verificationRequired) {
          Job.Actions.updatePhoneNumberEditRequested(true)
          JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Contact)
          return
        }

        this.setState({ verificationStatus: status,
                        submitEnabled: false,
                        verificationCodeHasError: true })
        return
      }

      this.setState({ verificationStatus: status,
                      verificationCodeHasError: false })
    },

    updateState: function(e) {
      var codeLength = this.getCode().length

      this.setState({ submitEnabled: codeLength === this.state.maxCodeLength })

      if (codeLength === this.state.maxCodeLength) {
        this.autoSubmitVerificationCode()
      } else if (codeLength > this.state.maxCodeLength) {
        $(e.target).val(this.getCode().slice(0, this.state.maxCodeLength))
      }
    },

    setupPhoneVerification: function(e) {
      var setupPhoneVerification = SS.API.V3.phoneVerificationGenerate()

      setupPhoneVerification.beforeSend = () => {
        this.setState({ loading: true })
      }

      $.ajax(setupPhoneVerification)
        .done((data) => {
          this.updateVerificationStatus(data.verification_status, data)
        })
        .always(() => {
          this.setState({ loading: false }, () => {
            $('#verifyNumberForm').find('input').focus()
          })
        })
    },

    getCode: function() {
      return $('#verifyNumberForm input').val()
    },

    handleCodeBlur: function() {
      this.setState({ verificationCodeHasError: false })
    },

    skipPhoneVerification: function(e) {
      e.preventDefault()

      var skipPhoneVerification = SS.API.V3.phoneVerificationSkip()

      skipPhoneVerification.beforeSend = () => {
        this.setState({ loading: true })
      }

      $.ajax(skipPhoneVerification)
        .always(() => {
          this.setState({ loading: false })
        })
        .done(() => {
          this.updateVerificationStatus('skipped')
        })
    },

    handleBackButtonClick: function(e) {
      e.preventDefault()
      SS.userPhoneIsValid = false
      SS.userPhoneVerified = false
      Job.Actions.updatePhoneNumberEditRequested(true)
      JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.Contact)
    },

    onSubmit: function(e) {
      e.preventDefault()
      this.verifyPhone().beforeSend = () => {
        this.setState({ loading: true })
      }

      $.ajax(this.verifyPhone())
        .done((data) => {
          this.updateVerificationStatus(data.verification_status)
        })
        .fail(() => {
          this.setState({ verificationStatus: 'invalid_code',
                          submitEnabled: true,
                          verificationCodeHasError: true })
        })
        .always(() => {
          this.setState({ loading: false })
        })
    },

    autoSubmitVerificationCode: function() {
      this.verifyPhone().beforeSend = () => {
        this.setState({ loading: true })
      }

      $.ajax(this.verifyPhone())
        .done((data) => {
          this.updateVerificationStatus(data.verification_status)
        })
        .fail(() => {
          this.setState({ verificationStatus: 'invalid_code',
                          submitEnabled: true,
                          verificationCodeHasError: true })
        })
        .always(() => {
          this.setState({ loading: false,
                          submitEnabled: true })
        })
    },

    verifyPhone: function() {
      return SS.API.V3.phoneVerificationVerify({ code: this.getCode() })
    },

    render: function() {
      var status = this.state.verificationStatus
      var verificationRequired = Job.Data.phoneVerificationRequired

      return (
        <div className="phone-verification-step">
          { this.state.loading ?
            <div className="modal-body">
              <div className="spinner-icon text-center"/>
            </div>
            :
            <div className="row pl24 pr24 pt16 pb0">
              <div className="col-sm-12 col-xs-12 mt0 mb0 pl0 pr0">
                <div className="text-center font-21 bold phone-verification-title">
                  Verify your phone number
                </div>
                <div className="mt24 mb0">
                  <div className="mb24 text-center text-copy-0 phone-verification-subtitle">
                    Enter the 4 digit code sent to your mobile number
                  </div>
                  { this.state.phoneNumber &&
                    <div className="mb24 text-center text-copy-1 bold">
                      { this.state.phoneNumber }
                    </div>
                  }
                  <div className="number-verification phone-verification-form" id="verifyNumberForm">
                    <div className="row mt24 mb8 font-24 bold col-md-10 col-centered pl0 pr0 sm-pl16 sm-pr16">
                      <div className="col-sm-12 col-xs-12">
                        <input className={`text-center verification-code-input ${this.state.verificationCodeHasError ? 'has-error' : ''}`}
                               type="text"
                               maxLength={this.state.maxCodeLength}
                               inputMode="numeric"
                               autoComplete="one-time-code"
                               pattern="[0-9]*"
                               placeholder="XXXX"
                               onChange={this.updateState}
                               onBlur={this.handleCodeBlur} />
                      </div>
                    </div>
                    <div className="col-sm-10 col-xs-12 p0 mt24 mb0 col-centered sm-pl16 sm-pr16">
                      <div className="row two-button-footer">
                        <div className='col-sm-6 col-xs-6 pl4 pull-right'>
                          <a href="#" id="submitVerification"
                             className={`btn btn-block btn-secondary p12 verification-continue ${(this.state.submitEnabled ? '' : 'disabled')}`}
                             onClick={this.onSubmit}>
                            Continue
                            <i className='ficon-arrow-right-shaft pl10 fs14' />
                          </a>
                        </div>
                        <div className='col-sm-6 col-xs-6 pull-left pr4'>
                          <a href="#"
                             className="btn btn-block btn-clear verification-change"
                             onClick={this.handleBackButtonClick}>
                            <i className='ficon-arrow-left-shaft pr10 fs14' />
                            Change number
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className={`col-sm-12 col-xs-12 mt8 mb0 ${(status === 'invalid_code' || status === 'failed' || status === 'unavailable') ? '' : 'hidden'}`}>
                      <span className="col-sm-12 col-xs-12 mb12 text-center text-red mt12">
                        {status === 'unavailable'
                          ? 'Invalid Mobile Number'
                          : 'That code doesn\'t match. Check the SMS and try again.'}
                      </span>
                    </div>

                    <div className="col-sm-12 col-xs-12 mt24 mb0">
                      <span className="col-sm-12 col-xs-12 mb32 text-center text-copy-0">
                        Didn't get the SMS? <a className="js-resend-code" href="#" onClick={this.setupPhoneVerification}>Send it again</a>
                      </span>
                    </div>
                    { !verificationRequired &&
                      <div className="col-sm-12 col-xs-12 mb0">
                        <span className="col-sm-12 col-xs-12 mb20 text-center text-copy-0">
                          <a id="skipPhoneVerification" href="#" onClick={this.skipPhoneVerification}>Skip this step</a>
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      )
    }
  })
}
